
import { Backdrop, Box, Button,  Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Link, SvgIconTypeMap, useTheme } from '@mui/material';
import React, {  useState } from 'react';
import { Mail, Phone, PhoneOutlined } from '@mui/icons-material';
import { AppNotificationTypeEnum } from "../../contexts/app-notification-context/AppNotificationContextTypes";
import { useAppNotificationContext } from "../../contexts/app-notification-context/UseAppNotificationContext";
import { useTranslation } from 'react-i18next';
import { Alert } from "@mui/material";
//import "@mui/lab";
import { OverridableComponent } from '@mui/material/OverridableComponent';

type ContactInfo = {
    text: string,
    href: string, 
    label: string,
    icon: OverridableComponent<SvgIconTypeMap<{}, "svg">>
};


export default function AppNotificationDialog() {
    
    const { t } = useTranslation();
    const [appNotificationState, setAppNotificationState] = useAppNotificationContext();
    const theme = useTheme();

    const handleClose = () => {
        setAppNotificationState({
            ...appNotificationState,
            show: false
        });
    };

    const [contactInfo,] = useState<ContactInfo[]>([{
        text: 'support@elynxtech.com',
        href: 'mailto:support@elynxtech.com',
        label: 'visit eLynx support',
        icon: Mail
    }, {
        text: 'USA: 1.866.303.5969',
        href: 'tel:1.866.303.5969',
        label: 'call eLynx support domestic',
        icon: Phone
    }, {
        text: 'Intl: +1.918.493.1321',
        href: 'tel:+1.918.493.1321',
        label: 'call eLynx support international',
        icon: PhoneOutlined
    }]);

    return (
        <Backdrop
            sx={{
                zIndex: theme.zIndex.drawer + 1,
                color: '#fff',
            }}
            open={appNotificationState.show && appNotificationState.notificationType !== AppNotificationTypeEnum.Success}>

            <Dialog
                fullWidth={true}
                maxWidth="sm"
                open={appNotificationState.show  && appNotificationState.notificationType !== AppNotificationTypeEnum.Success}
                onClose={(_event: Event, reason: string) => {
                    if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
                        handleClose();
                    }
                }}
                aria-labelledby="notification-dialog-title"
                aria-describedby="notification-dialog-description"
            >
                {appNotificationState.title && 
                    <DialogTitle id="notification-dialog-title">{appNotificationState.title}</DialogTitle>
                }

                <DialogContent>
                    <DialogContentText id="notification-dialog-description" component='div'>
                        <Alert severity={ appNotificationState.notificationType === AppNotificationTypeEnum.Error ? "error" :
                             appNotificationState.notificationType === AppNotificationTypeEnum.Warning ? "warning" : 
                             "info"}>
                            {appNotificationState.message}
                        </Alert>                        
                    </DialogContentText>


                    {!appNotificationState.hideContactInfo && 

                        <Box
                            sx={{
                                flexDirection: 'column'
                            }}>
                            {
                            contactInfo.map((item, index) => (
                                <Box key={index}>

                                    <Link style={{whiteSpace: 'nowrap'}} 
                                        aria-label={item.label} 
                                        color="textPrimary" 
                                        href={item.href} 
                                        target="_blank">

                                        <IconButton component="span">
                                            {<item.icon />}
                                        </IconButton>
                                        {item.text}

                                    </Link>
                                </Box>
                            ))
                            }

                        </Box> }

                </DialogContent>

                <DialogActions>
                <Button onClick={handleClose} autoFocus>
                    {t("buttons.close")}
                </Button>
                </DialogActions>
            </Dialog>

        </Backdrop>
    );
  }
